export default __webpack_public_path__ + "static/media/defaultLogo.440bf51f.svg";